/* eslint-disable react/jsx-no-bind */
import * as React from 'react';
import PropTypes from 'prop-types';
import { Link, Redirect } from 'react-router-dom';
import MetaTags from 'react-meta-tags';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PageLoading from '../common/PageLoading';
import * as discussionActions from '../../actions/discussionActions';
import ToastrService from '../../services/toastrService';
import Error from '../common/Error.js';
import ErrorMessage from '../common/ErrorMessage.js';
import * as imageUtils from '../../utils/imageUtils';

class NewDiscussionPage extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.createDiscussion = this.createDiscussion.bind(this);
        this.isSubmitEnabled = this.isSubmitEnabled.bind(this);
        this.getSubmitError = this.getSubmitError.bind(this);
        this.state = {
            loading: false,
            title: '',
            message: '',
            submitting: false
        };
    }

    componentWillMount() {
        if(!this.props.section) {
            this.setState({ loading: true });
            this.props.actions.getSections()
                .then(_ => {
                    this.setState({ loading: false });
                    if(!this.props.section) {
                        const toastrService = new ToastrService();
                        toastrService.showError('', 'Invalid discussion category');
                        this.props.history.push('/Discussions');
                    }
                })
                .catch(error => {
                    this.setState({ loading: false });
                });
        }        
        if(!this.isSubmitEnabled) {
            this.setState({ error: this.isSubmitEnabled(this.props) });
        }
    }

    componentWillUpdate(nextProps, nextState) {
        if(this.props.user !== nextProps.user || this.props.activeProfile !== nextProps.activeProfile) {
            this.setState({ error: this.isSubmitEnabled(nextProps) });
        }
    }   
    
    componentDidUpdate(prevProps) {              
        
    }

    getThumbnail(imageUrl, roleType) {
        const params = '?width=40&aspectw=1&quality=80&mode=crop&format=jpg';
        return imageUtils.getThumbnail(imageUrl, roleType, params);
    }

    isSubmitEnabled(event, props = this.props) {
        return props.activeProfile && props.user.Confirmed;
    }

    getSubmitError() {
        if(!this.props.activeProfile) {
            return 'Sorry, you need to create a profile before you can add a new discussion!';
        }
        else if(!this.props.user.Confirmed) {
            return 'Sorry, you need to confirm your email address before you can add a new discussion';
        }
        else {
            return '';
        }
    }

    createDiscussion(event) {
        event.preventDefault();
        this.setState({ submitting: true });
        const sectionLink = this.props.match.params.sectionLink;
        const newDiscussion = { profileID: this.props.activeProfile.ID, title: this.state.title, message: this.state.message };
        this.props.actions.addDiscussion(sectionLink, newDiscussion)
            .then(discussion => {    
                this.props.history.push(`/Discussions/${sectionLink}/${discussion.Link}`);
                this.props.actions.getDiscussions(sectionLink, 1, true);
                const toastrService = new ToastrService();
                toastrService.showSuccess('', 'Your discussion has been created!');
                this.setState({ title: '', message: '', submitting: false });
            })
            .catch(error => {
                this.setState({ error: error.message, submitting: false });
            });
    }

    render() {
        const submitError = this.getSubmitError();
        return (
            <div className="main">
                {
                    this.props.section ?
                        <React.Fragment>                               
                            <MetaTags>      
                                <title>{`Post a new discussion - ${this.props.section.Name} - LoudUp`}</title>   
                                <meta id="description" name="description" content={`Post a new discussion to the - ${this.props.section.Name} section`} />   
                            </MetaTags>
                            <div className="container">
                                <div className="block-inner">
                                    <h1 className="section-alt">Discussions</h1>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div>
                                                <div className="discbread">
                                                    <ol className="breadcrumb">
                                                        <li><Link to={'/Discussions'}>Discussions</Link></li>
                                                        <li className="active"><Link to={`/Discussions/${this.props.section.Link}`}>{this.props.section.Name}</Link></li>
                                                    </ol>
                                                </div>                                            
                                                <div className="discfeed">
                                                    <h2>Add a New Discussion</h2>
                                                    <div className="userthumb">
                                                        <img src={this.getThumbnail(this.props.activeProfile ? this.props.activeProfile.DefaultImage : null, this.props.activeProfile ? this.props.activeProfile.RoleType: 'Fan')} alt={this.props.activeProfile ? this.props.activeProfile.DisplayName : ''} />
                                                    </div>
                                                    <form id="frmNewDiscussion" className="form-regular" onSubmit={this.createDiscussion}>
                                                        <ErrorMessage error={submitError ? submitError : this.state.error} onClose={submitError ? null : () => this.setState({ error: null })} />
                                                        <div className="form-group form-pre">
                                                            <input type="text" name="Title" placeholder="Title" className="inputfield form-control transition" required value={this.state.title} onChange={(event) => this.setState({ title: event.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <textarea name="Message" placeholder="Message" className="inputfield form-control inputfield input-area showremainingchars" required cols = "20" rows = "4" maxLength={500} value={this.state.message} onChange={(event) => this.setState({ message: event.target.value })} />
                                                        </div>
                                                        <span id="remainingChars" style={{float: 'right', color:'#aaa'}}>{this.state.message ? 500 - this.state.message.length : ''}</span>
                                                        <div className="form-group formspace" style={{clear:'both'}}>
                                                            <div className="row">
                                                                <div className="col-sm-3">
                                                                    <input type="submit" value="POST" className="btn btn-primary btn-block btn-post" disabled={!this.isSubmitEnabled() || this.state.submitting} />
                                                                </div>
                                                                <div className="col-sm-9">
                                                                    <p className="smalltype">Warning: posting abusive, offensive, or spam messages will result in being sent to a sad place far, far away where there are no beats or riffs or bass lines...or banned from here at the very least!</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    :
                        this.state.loading ? <PageLoading /> : <Error />
                }                
            </div>
        );
    }
}

NewDiscussionPage.propTypes = {
    section: PropTypes.object,
    actions: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    activeProfile: PropTypes.object.isRequired,
    user: PropTypes.object,
    match: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {    
    const sectionLink = ownProps.match.params.sectionLink;
    return {
        section: state.discussions.sections ? state.discussions.sections.find(s => s.Link === sectionLink) : null,
        user: state.account.user,
        activeProfile: state.account.user.activeProfile
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, discussionActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewDiscussionPage);